import { z } from 'zod';
import { idSchema, isoDateSchema, memberSummarySchema } from './common';
import { rumTypeSchema } from '../enums';
import { GUESS_MAX_SCORE } from '../score';
/**
 * Écran 05 — pronostic à l'aveugle (US-14).
 * Tous les champs sont facultatifs : on peut ne parier que sur le pays.
 */
export const upsertGuessSchema = z.object({
    sessionId: idSchema,
    rumId: idSchema,
    country: z.string().trim().max(80).nullish(),
    rumType: rumTypeSchema.nullish(),
    abvGuess: z.number().min(0).max(100).nullish(),
    ageGuess: z.number().int().min(0).max(100).nullish(),
    /** true = « Verrouiller mon pronostic » : plus aucune modification ensuite. */
    lock: z.boolean().default(false),
    clientUpdatedAt: isoDateSchema,
});
export const guessViewSchema = z.object({
    sessionId: idSchema,
    rumId: idSchema,
    member: memberSummarySchema,
    country: z.string().nullable(),
    rumType: rumTypeSchema.nullable(),
    abvGuess: z.number().nullable(),
    ageGuess: z.number().nullable(),
    lockedAt: isoDateSchema.nullable(),
    /** Renseigné à la révélation uniquement — null avant, sinon le barème fuiterait. */
    score: z.number().int().min(0).max(GUESS_MAX_SCORE).nullable(),
});
/** Écran 05 — « 4 membres sur 5 ont validé », sans dire *qui*. */
export const blindProgressSchema = z.object({
    sessionId: idSchema,
    rumId: idSchema,
    lockedGuesses: z.number().int(),
    expectedGuesses: z.number().int(),
    revealedAt: isoDateSchema.nullable(),
});
/** Écran 06 — le podium des pronostics et la désignation du meilleur nez. */
export const revealResultSchema = z.object({
    sessionId: idSchema,
    rumId: idSchema,
    revealedAt: isoDateSchema,
    /** La fiche enfin démasquée. */
    rum: z.object({
        id: idSchema,
        name: z.string(),
        distillery: z.string().nullable(),
        country: z.string().nullable(),
        rumType: rumTypeSchema.nullable(),
        abv: z.number().nullable(),
        age: z.number().nullable(),
        photoUrl: z.string().nullable(),
    }),
    podium: z.array(z.object({
        rank: z.number().int(),
        member: memberSummarySchema,
        score: z.number().int(),
        /** Détail lisible : « Pays ✓ · Type ✓ · 54 % ». */
        detail: z.string(),
    })),
    bestNoseMemberId: idSchema.nullable(),
    /** Notes comparées, affichées en même temps que la révélation. */
    tastings: z.array(z.object({
        member: memberSummarySchema,
        overall: z.number().int(),
    })),
    average: z.number().int().nullable(),
});
//# sourceMappingURL=guess.js.map